import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import Login from '@/views/Login.vue'
import Users from '@/views/Users.vue'
import SupportUser from '@/views/SupportUser.vue'
import Tenants from '@/views/Tenants.vue'
import PortalUsers from '@/views/PortalUsers.vue'
import { beforeEachRouterEntry } from '@/before-each-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/accounts/detail',
      name: 'customer',
      component: Users,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/support-user',
      name: 'support-user',
      component: SupportUser,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/accounts',
      name: 'tenants',
      component: Tenants,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/portal-users',
      name: 'portal-users',
      component: PortalUsers,
      meta: {
        requiresAuth: true,
      },
    },
  ],
})

router.beforeEach(beforeEachRouterEntry)

export default router
